import { Typography as e } from "../../Typography/Typography.mjs";
import { Skeleton as t } from "../Primitives/Skeleton.mjs";
import { Widget as n } from "../Widget/Widget.mjs";
import "react";
import { css as r, styled as i } from "styled-components";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/StatCard/StatCard.tsx
var s = i(n)`
    ${({ theme: e, $tone: t }) => t === "danger" && r`
            border: 1px solid ${e.colors.destructive};
        `}
    ${({ theme: e, $tone: t }) => t === "warning" && r`
            border: 1px solid ${e.colors.warning};
        `}
`, c = ({ title: r, value: i, subtitle: c, tone: l, loading: u, action: d, className: f }) => /* @__PURE__ */ o(s, {
	className: f,
	$tone: l,
	children: [/* @__PURE__ */ a(n.Header, {
		title: r,
		action: d
	}), /* @__PURE__ */ o(n.Content, { children: [u ? /* @__PURE__ */ a(t, {
		width: 120,
		height: 26
	}) : /* @__PURE__ */ a(e, {
		variant: "h3",
		weight: "bold",
		children: i
	}), c !== void 0 && /* @__PURE__ */ a(e, {
		variant: "small",
		color: "secondary",
		children: c
	})] })]
});
//#endregion
export { c as StatCard };
